import { TranslatedField } from '../models';

const fallbackLanguages = {
  fr: ['fr', 'nl', 'de'],
  nl: ['nl', 'fr', 'de'],
  de: ['de', 'fr', 'nl']
};

export function getTranslatedText(names: TranslatedField[], lang: string): string {
  if (!names) {
    return undefined;
  }
  lang = lang?.substring(0, 2);
  for (let l of fallbackLanguages[lang]) {
    const translation = names.find(n => n.lang === l);
    if (translation) {
      return translation.value;
    }
  }
  return names.length > 0 ? names[0].value : 'Missing translation';
}

export function getTranslatedObject(object, lang: string) {
  if (!object || Object.keys(object).length < 1) {
    return undefined;
  }
  lang = lang?.substring(0, 2);
  for (let l of fallbackLanguages[lang]) {
    const translation = object.find(n => n.lang === l);
    if (translation) {
      return translation;
    }
  }
  return object.length > 0 ? object[0] : undefined;
}
